import _defineProperty from "/Users/felipe.ramirez/Documents/quattro/valve_inventory_crystin/valve_inventory_app_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/felipe.ramirez/Documents/quattro/valve_inventory_crystin/valve_inventory_app_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import classNames from 'classnames';
import * as React from 'react';
import useClosable from '../_util/hooks/useClosable';
var DrawerPanel = function DrawerPanel(props) {
  var prefixCls = props.prefixCls,
    title = props.title,
    footer = props.footer,
    extra = props.extra,
    closeIcon = props.closeIcon,
    closable = props.closable,
    onClose = props.onClose,
    headerStyle = props.headerStyle,
    drawerStyle = props.drawerStyle,
    bodyStyle = props.bodyStyle,
    footerStyle = props.footerStyle,
    children = props.children;
  var customCloseIconRender = React.useCallback(function (icon) {
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, icon);
  }, [onClose]);
  var _useClosable = useClosable(closable, closeIcon, customCloseIconRender, undefined, true),
    _useClosable2 = _slicedToArray(_useClosable, 2),
    mergedClosable = _useClosable2[0],
    mergedCloseIcon = _useClosable2[1];
  var headerNode = React.useMemo(function () {
    if (!title && !mergedClosable) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      style: headerStyle,
      className: classNames("".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-header-close-only"), mergedClosable && !title && !extra))
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-header-title")
    }, mergedCloseIcon, title && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-title")
    }, title)), extra && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-extra")
    }, extra));
  }, [mergedClosable, mergedCloseIcon, extra, headerStyle, prefixCls, title]);
  var footerNode = React.useMemo(function () {
    if (!footer) {
      return null;
    }
    var footerClassName = "".concat(prefixCls, "-footer");
    return /*#__PURE__*/React.createElement("div", {
      className: footerClassName,
      style: footerStyle
    }, footer);
  }, [footer, footerStyle, prefixCls]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-wrapper-body"),
    style: drawerStyle
  }, headerNode, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body"),
    style: bodyStyle
  }, children), footerNode);
};
export default DrawerPanel;